import { withDefault, ArrayParam, BooleanParam } from 'use-query-params';

export const defaultFilterValues = {
  customers: [],
  teams: [],
  branches: [],
  offices: [],
  responsibleGroups: [],
  withAdvancePayment: undefined,
};

export const defaultQueryParams = {
  customers: withDefault(ArrayParam, []), // клиенты
  teams: withDefault(ArrayParam, []), // команда
  branches: withDefault(ArrayParam, []), // филиалы - новый фильтр
  offices: withDefault(ArrayParam, []), // отдел
  responsibleGroups: withDefault(ArrayParam, []), // ответственный отдел - новый фильтр
  withAdvancePayment: withDefault(BooleanParam, undefined), // с авансом - новый фильтр
};
